import React from 'react';

const PageHeader = () => {
  return (
    <header id='header'>
      <div>
        <h1>yabu PortfolioSite</h1>
        <p>student engineer / yabu</p>
      </div>

      <nav>
        <ul>
          <li>
            <a href="/">return Site</a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default PageHeader;
